import React, { type ComponentType } from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import type { Configuration } from './types.tsx';

export function withRedirection(
	Component: ComponentType,
	{ to, redirectCondition }: Configuration,
) {
	return () => {
		const [{ match }] = useRouter();
		if (
			match == null ||
			match.params == null ||
			match.params.planId == null ||
			match.params.scenarioId == null
		) {
			return <ScreenRedirect to="/jira/plans" />;
		}

		if (!redirectCondition()) {
			return <Component />;
		}
		return (
			<ScreenRedirect
				to={`/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`}
			/>
		);
	};
}
